import { Spinner } from "react-bootstrap"

const SpinnerLoader = () => {
    return (
        <div className='loading_spinner'><Spinner animation="grow" /></div>
    )
}

export default SpinnerLoader